import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpdateInvitationState } from "./types";
import { IInvitation } from "@/shared/api/invitations";
import { RoleType } from "@/shared/api/users";

const initialState: UpdateInvitationState = {
    isInspectInvitationModalOpen: false,
    isCreateInvitationModalOpen: false,
    isDeleteInvitationModalOpen: false,
    currentInvitation: {
        id: "",
        group_id: "",
        type: "",
        permanent: false,
        link: "",
        group: {
            name: "",
            id: ""
        },
        role: {
            name: "",
            id: ""
        },
        total_redirects: 0
    },
    onCreate: null,
    role: "users",
    onDelete: null
}

interface OpenCreateInvitationModal {
    role: RoleType
    onCreate?: () => void
}
interface OpenInspectInvitationModal {
    data: IInvitation
}
interface OpenDeleteInvitationModal {
    data: IInvitation
    onDelete?: () => void
}

const updateInvitationSlice = createSlice({
    name: 'updateInvitation',
    initialState,
    reducers: {
        openCreateInvitationModal: (state, action: PayloadAction<OpenCreateInvitationModal>) => {
            state.role = action.payload.role
            state.onCreate = action.payload.onCreate
            state.isCreateInvitationModalOpen = true
        },
        openInspectInvitationModal: (state, action: PayloadAction<OpenInspectInvitationModal>) => {
            state.currentInvitation = action.payload.data
            state.isInspectInvitationModalOpen = true
        },
        openDeleteInvitationModal: (state, action: PayloadAction<OpenDeleteInvitationModal>) => {
            state.currentInvitation = action.payload.data
            state.onDelete = action.payload.onDelete
            state.isDeleteInvitationModalOpen = true
        },
        closeCreateInvitationModal: (state) => {
            state.isCreateInvitationModalOpen = false
        },
        closeInspectInvitationModal: (state) => {
            state.isInspectInvitationModalOpen = false
        },
        closeDeleteInvitationModal: (state) => {
            state.isDeleteInvitationModalOpen = false
        },
    }
})

export default updateInvitationSlice.reducer
export const {
    closeCreateInvitationModal,
    closeDeleteInvitationModal,
    closeInspectInvitationModal,
    openCreateInvitationModal,
    openDeleteInvitationModal,
    openInspectInvitationModal,
} = updateInvitationSlice.actions